"use strict";

var _regeneratorRuntime = require("/home/runner/work/create-react-app-example/create-react-app-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/runner/work/create-react-app-example/create-react-app-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/create-react-app-example/create-react-app-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

var jsonapi_errors_1 = require("./jsonapi_errors");

var qs_1 = require("qs");
/**
 * Options for HttpClient.
 *
 * @todo see https://github.com/octokit/request.js/blob/master/src/fetch-wrapper.ts
 */


var HttpClient = /*#__PURE__*/function () {
  function HttpClient(apiUrl, apiPrefix, cartToken, storeId, authorization) {
    _classCallCheck(this, HttpClient);

    // remove any trailing slashes.
    apiUrl = apiUrl.replace(/\/$/, '');

    if (apiPrefix.substring(0, 1) !== '/') {
      throw new Error('apiPrefix must begin with "/"');
    }

    this.apiPrefix = apiPrefix;
    this.apiUrl = apiUrl; // ensure a cart token.

    this.cartToken = cartToken || utils_1.generateCartToken();
    this.storeId = storeId;
    this.authorization = authorization;
  }
  /**
   * Get the API entrypoint.
   */


  _createClass(HttpClient, [{
    key: "getEntrypoint",
    value: function getEntrypoint() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.request("/");

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getCart",
    value: function getCart(fields) {
      var includes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['order_items', 'order_items.purchased_entity'];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var json, data, included;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.request("/carts", {
                  fields: fields,
                  includes: includes
                });

              case 2:
                json = _context2.sent;
                data = json === null || json === void 0 ? void 0 : json.data;
                included = json === null || json === void 0 ? void 0 : json.included;

                if (data) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('unexpected data format');

              case 7:
                if (!Array.isArray(data)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", {
                  cart: data[0],
                  included: included
                });

              case 11:
                return _context2.abrupt("return", {
                  cart: data,
                  included: included
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "addToCart",
    value: function addToCart(purchasableEntity, quantity, fields) {
      var includes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['order_id', 'order_id.order_items', 'order_id.order_items.purchased_entity'];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var json, data, included, cartItem, mappedIncludes, cart;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.request("/cart/add", {
                  fields: fields,
                  includes: includes
                }, {
                  method: 'POST',
                  body: JSON.stringify({
                    data: [{
                      type: purchasableEntity.type,
                      id: purchasableEntity.id,
                      meta: {
                        quantity: quantity
                      }
                    }]
                  })
                });

              case 2:
                json = _context3.sent;
                data = json.data, included = json.included;

                if (data) {
                  _context3.next = 6;
                  break;
                }

                throw new Error('unexpected data format');

              case 6:
                cartItem = Array.isArray(data) ? data[0] : data;
                mappedIncludes = utils_1.getMappedIncludes(json.included);
                cart = utils_1.getRelationshipFromMappedIncludes(cartItem, 'order_id', mappedIncludes);

                if (!(!cart || Array.isArray(cart))) {
                  _context3.next = 11;
                  break;
                }

                throw new Error('unexpected data format');

              case 11:
                return _context3.abrupt("return", {
                  cartItem: cartItem,
                  cart: cart,
                  included: included
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "updateCartItem",
    value: function updateCartItem(cartItem, quantity, fields) {
      var includes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['order_id', 'order_id.order_items', 'order_id.order_items.purchased_entity'];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var cartId, json, data, included, patchedCartItem, mappedIncludes, cart;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (cartItem.relationships.order_id) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('invalid cart item object');

              case 2:
                cartId = cartItem.relationships.order_id.data.id;
                _context4.next = 5;
                return this.request("/carts/".concat(cartId, "/items/").concat(cartItem.id), {
                  fields: fields,
                  includes: includes
                }, {
                  method: 'PATCH',
                  body: JSON.stringify({
                    data: {
                      type: cartItem.type,
                      id: cartItem.id,
                      attributes: {
                        quantity: quantity
                      }
                    }
                  })
                });

              case 5:
                json = _context4.sent;
                data = json === null || json === void 0 ? void 0 : json.data;
                included = json === null || json === void 0 ? void 0 : json.included;

                if (data) {
                  _context4.next = 10;
                  break;
                }

                throw new Error('unexpected data format');

              case 10:
                if (Array.isArray(data)) {
                  patchedCartItem = data[0];
                } else {
                  patchedCartItem = data;
                }

                mappedIncludes = utils_1.getMappedIncludes(json.included);
                cart = utils_1.getRelationshipFromMappedIncludes(patchedCartItem, 'order_id', mappedIncludes);
                return _context4.abrupt("return", {
                  cartItem: patchedCartItem,
                  cart: cart,
                  included: included
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "removeCartItem",
    value: function removeCartItem(cartItem) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var cartId;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (cartItem.relationships.order_id) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('invalid cart item object');

              case 2:
                cartId = cartItem.relationships.order_id.data.id;
                _context5.next = 5;
                return this.request("/carts/".concat(cartId, "/items"), undefined, {
                  method: 'DELETE',
                  body: JSON.stringify({
                    data: [{
                      type: cartItem.type,
                      id: cartItem.id
                    }]
                  })
                });

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "applyPromotionalCode",
    value: function applyPromotionalCode(cart, promotionalCode) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.request("/carts/".concat(cart.id, "/coupons"), undefined, {
                  method: 'PATCH',
                  body: JSON.stringify({
                    data: [{
                      type: 'promotion-coupon',
                      id: promotionalCode
                    }]
                  })
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getCheckout",
    value: function getCheckout(cart, fields) {
      var includes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['order_items', 'order_items.purchased_entity'];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var json, data, included;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.request("/checkout/".concat(cart.id), {
                  includes: includes,
                  fields: fields
                });

              case 2:
                json = _context7.sent;
                data = json === null || json === void 0 ? void 0 : json.data;
                included = json === null || json === void 0 ? void 0 : json.included;

                if (data) {
                  _context7.next = 7;
                  break;
                }

                throw new Error('unexpected data format');

              case 7:
                return _context7.abrupt("return", {
                  cart: data,
                  included: included
                });

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "patchCheckout",
    value: function patchCheckout(cart, attributes, fields) {
      var includes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['order_items', 'order_items.purchased_entity'];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var json, data, included;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.request("/checkout/".concat(cart.id), {
                  includes: includes,
                  fields: fields
                }, {
                  method: 'PATCH',
                  body: JSON.stringify({
                    data: {
                      type: cart.type,
                      id: cart.id,
                      attributes: attributes
                    }
                  })
                });

              case 2:
                json = _context8.sent;
                data = json === null || json === void 0 ? void 0 : json.data;
                included = json === null || json === void 0 ? void 0 : json.included;

                if (data) {
                  _context8.next = 7;
                  break;
                }

                throw new Error('unexpected data format');

              case 7:
                return _context8.abrupt("return", {
                  cart: data,
                  included: included
                });

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "requestOptionsToQuery",
    value: function requestOptionsToQuery(options) {
      if (!options) {
        return '';
      }

      var query = {};

      if (options.includes) {
        query.include = options.includes.join(',');
      }

      if (options.fields) {
        query.fields = {};

        for (var key in options.fields) {
          if (options.fields.hasOwnProperty(key)) {
            query.fields[key] = options.fields[key].join(',');
          }
        }
      }

      if (options.filter) {
        query.filter = {};

        for (var _key in options.filter) {
          if (options.filter.hasOwnProperty(_key)) {
            query.filter[_key] = options.filter[_key];
          }
        }
      }

      if (options.sort) {
        query.sort = options.sort.join(',');
      }

      if (options.page) {
        query.page = options.page;
      }

      return "?" + qs_1.stringify(query);
    }
    /**
     * Perform a request against the API.
     *
     * @param input path
     * @param options
     * @param init options
     */

  }, {
    key: "request",
    value: function request(input, options, init) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var queryString, requestUrl, request, res, json;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                queryString = this.requestOptionsToQuery(options);
                requestUrl = ''; // If an absolute URL was passed, use that.

                if (/^https?:\/\//i.test(input.toString())) {
                  requestUrl = "".concat(input.toString()).concat(queryString);
                } else {
                  // If the API prefix is missing, prepend it.
                  if (input.toString().indexOf(this.apiPrefix) !== 0) {
                    input = "".concat(this.apiPrefix).concat(input);
                  }

                  requestUrl = "".concat(this.apiUrl).concat(input).concat(queryString);
                }

                request = new Request(requestUrl, init);
                request.headers.set('Accept', 'application/vnd.api+json');
                request.headers.set('Commerce-Cart-Token', this.cartToken);

                if (this.storeId) {
                  request.headers.set('Commerce-Current-Store', this.storeId);
                }

                if (this.authorization) {
                  request.headers.set('Authorization', this.authorization);
                }

                if (init && init.method && ['POST', 'PATCH', 'DELETE'].includes(init.method)) {
                  request.headers.set('Content-Type', 'application/vnd.api+json');
                }

                _context9.prev = 9;
                _context9.next = 12;
                return fetch(request);

              case 12:
                res = _context9.sent;
                _context9.next = 18;
                break;

              case 15:
                _context9.prev = 15;
                _context9.t0 = _context9["catch"](9);
                throw new jsonapi_errors_1.JsonApiErrors([{
                  code: '000',
                  title: _context9.t0.message
                }]);

              case 18:
                if (!(res.status === 204)) {
                  _context9.next = 20;
                  break;
                }

                return _context9.abrupt("return", {});

              case 20:
                if (!(res.headers.get('Content-Type') !== 'application/vnd.api+json')) {
                  _context9.next = 22;
                  break;
                }

                throw new jsonapi_errors_1.JsonApiErrors([{
                  code: '000',
                  status: res.status.toString(),
                  title: 'response did not return JSON:API'
                }]);

              case 22:
                _context9.next = 24;
                return res.json();

              case 24:
                json = _context9.sent;

                if (!res.ok) {
                  _context9.next = 29;
                  break;
                }

                return _context9.abrupt("return", json);

              case 29:
                if (!json.errors) {
                  _context9.next = 33;
                  break;
                }

                throw jsonapi_errors_1.JsonApiErrors.fromResponse(json);

              case 33:
                throw new jsonapi_errors_1.JsonApiErrors([{
                  code: '000',
                  title: 'unknown error'
                }]);

              case 34:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[9, 15]]);
      }));
    }
  }]);

  return HttpClient;
}();

exports.HttpClient = HttpClient;